<template>
  <v-dialog :value="dialog" max-width="1200" @input="handler">
    <v-card>
      <!-- 搜索栏  -->
      <v-toolbar color="success">
        <v-toolbar-title class="white--text">
          <div style="padding-left: 20px">资源库</div>
        </v-toolbar-title>
        <v-btn icon class="ml-2" @click.stop="handleResourceNew">
          <v-icon style="color: white">mdi-plus</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <div class="d-sm-flex justify-between" v-if="!defaultType">
          <div class="d-flex ms-auto">
            <v-menu
              transition="slide-y-transition"
              offset-y
              nudge-bottom="5"
              :close-on-click="true"
            >
              <template v-slot:activator="{ on, attrs, value }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="md-button md-success dropdown-toggle"
                >
                  资源类型
                  <v-icon :class="['ni', value ? 'rotate-180' : '']"
                    >ni ni-bold-down text-xs ms-1</v-icon
                  >
                </v-btn>
              </template>

              <v-list class="py-1" dense max-height="300">
                <v-list-item-group
                  active-class="v-List-actived"
                  mandatory
                  color="indigo"
                >
                  <v-list-item
                    class="list-item-hover-active py-0 text-center"
                    v-for="(item, index) in zyTypeList"
                    :key="index"
                    @click="zyTypeSelected(item)"
                  >
                    <v-list-item-content class="pa-0">
                      <v-list-item-title
                        class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                      >
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <v-btn
              class="md-button md-success dropdown-toggle"
              @click="clearFilter"
            >
              清除筛选
              <md-icon>filter_list_off</md-icon>
            </v-btn>
          </div>
        </div>
      </v-toolbar>

      <v-toolbar flat height="80">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formSearch.name"
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-magnify"
              label="请输入名称"
              single-line
              hide-details
              @keydown="keydownSearch"
            ></v-text-field>
          </template>
          <span>按回车以检索</span>
        </v-tooltip>
      </v-toolbar>
      <div class="max-vh-50 overflow-auto pa-5" style="width: 100%">
        <v-row dense>
          <v-col class="px-1" cols="12" v-show="loading"
            ><v-progress-linear
              :active="loading"
              :indeterminate="loading"
            ></v-progress-linear
          ></v-col>
          <v-col cols="10">
            <v-row dense>
              <v-col
                v-for="(item, index) in list"
                :key="index"
                cols="3"
                class="py-1"
              >
                <v-hover>
                  <template v-slot:default="{ hover }">
                    <v-expand-transition>
                      <v-card
                        hover
                        :class="[
                          `elevation-${hover ? 20 : 2}`,
                          'mx-2',
                          'transition-swing',
                        ]"
                        @click="handleResourcePreview(item)"
                      >
                        <v-img
                          v-if="item.type === '0'"
                          :src="item.fullPath"
                          class="white--text align-end"
                          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                          height="200px"
                        >
                          <v-card-title>{{ item.name }}</v-card-title>
                        </v-img>
                        <v-img
                          v-if="item.type === '1'"
                          :src="item.fullPath"
                          class="white--text align-end"
                          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                          height="200px"
                        >
                          <v-card-title>{{ item.name }}</v-card-title>
                        </v-img>
                        <v-img
                          v-if="item.type === '2'"
                          src="~@/assets/img/word.png"
                          class="white--text align-end"
                          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                          height="200px"
                          cover
                        >
                          <v-card-title>{{ item.name }}</v-card-title>
                        </v-img>
                        <v-img
                          v-if="item.type === '3'"
                          src="~@/assets/img/word.png"
                          class="white--text align-end"
                          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                          height="200px"
                        >
                          <v-card-title>{{ item.name }}</v-card-title>
                        </v-img>
                        <v-img
                          v-if="item.type === '4'"
                          src="~@/assets/img/word2.png"
                          class="white--text align-end"
                          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                          height="200px"
                        >
                          <v-card-title>{{ item.name }}</v-card-title>
                        </v-img>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            :color="
                              !selectedResource[item._id] ? 'success' : 'error'
                            "
                            text
                            small
                            @click.stop="choose(item)"
                            >{{
                              !selectedResource[item._id] ? "选择" : "取消选择"
                            }}</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-expand-transition>
                  </template>
                </v-hover>
              </v-col>
              <v-col cols="12">
                <Pagination
                  :page.sync="pagination.page"
                  :total="pagination.total"
                  :itemsSelect="[4, 8, 20, 40]"
                  :items-per-page.sync="pagination.itemsPerPage"
                  @refresh="refreshResourceList"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="2">
            <v-list dense>
              <v-subheader>选择的资源</v-subheader>
              <v-list-item-group color="success">
                <v-list-item v-for="(item, i) in chooseResourceArr" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn small icon color="error" @click.stop="choose(item)">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </div>
      <div class="py-4 px-4 text-right">
        <v-spacer></v-spacer>
        <v-btn color="success" dark @click.stop="submit">确认</v-btn>
        <v-btn class="ml-2" color="gray" @click.stop="cancel">取消</v-btn>
      </div>

      <ResourceLibraryFrom
        ref="ResourceLibraryFrom"
        :dialog-edit.sync="dialogFrom"
        :title="dialotitle"
        :form-data="editedItem"
        @submit="handleSubmit"
        @closeDialog="closeDialog"
      />
    </v-card>
  </v-dialog>
</template>
<script>
import { ImageCard } from "@/components";
import Pagination from "@/components/Pagination/index";
import { ModelGltf } from "vue-3d-model";
import {
  listResourceLibrary,
  addResourceLibrary,
  updateResourceLibrary,
} from "@/api/resource_library";
import { _Base64encode } from "@/util/base64";
import ResourceLibraryFrom from "@/pages/Dashboard/Resource/Action/ResourceLibraryFrom";

export default {
  components: {
    ImageCard,
    Pagination,
    ModelGltf,
    ResourceLibraryFrom,
  },
  props: {
    checkMod: {
      type: Array,
      default: () => [],
    },
    dialogEdit: {
      type: Boolean,
      default: false,
    },
    defaultType: {
      type: String,
      default: "",
    },
    maxNumber: {
      type: Number,
      default: -1, // -1表示无限制（可选择数量）
    },
  },
  data() {
    return {
      formSearch: {
        name: "",
        type: "",
      },
      zyTypeList: [
        { name: "全部", type: "" },
        { name: "图片", type: "0" },
        { name: "视频", type: "1" },
        { name: "音频", type: "2" },
        { name: "文档", type: "3" },
        { name: "其他", type: "4" },
      ],
      list: [],
      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 4,
        total: 0,
      },
      selectedResource: {},
      chooseResourceArr: [],
      loading: false,
      dialogFrom: false,
      editedItem: {},
      dialotitle: "",
    };
  },
  computed: {
    dialog: {
      get() {
        return this.dialogEdit;
      },
    },
  },
  watch: {
    currentPage(val) {
      this.refreshResourceList();
    },
    dialogEdit: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.chooseResourceArr = this.checkMod.filter((item) => {
            return item._id;
          });
          this.selectedResource = this.chooseResourceArr.reduce(
            (map, model) => {
              map[model._id] = model;
              return map;
            },
            {}
          );
        }
      },
      immediate: true,
      deep: true,
    },
    defaultType: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.refreshResourceList();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.refreshResourceList();
  },
  methods: {
    // 清楚筛选
    clearFilter() {
      this.formSearch = {
        name: "",
        type: "",
      };
      this.refreshResourceList();
    },
    // 选择资料类型
    zyTypeSelected(e) {
      this.formSearch.type = e.type;
      this.pagination.page = 1;
      this.refreshResourceList();
    },
    // 列表刷新
    refreshResourceList() {
      this.formSearch.type = this.defaultType;
      let query = {
        ...this.formSearch,
        currentPage: this.pagination.page,
        perPage: this.pagination.itemsPerPage,
      };
      this.loading = true;
      listResourceLibrary(query).then((res) => {
        this.list = res.data.rows;
        this.pagination.total = res.data.total;
        this.loading = false;
      });
    },
    // 文件预览
    handleResourcePreview(item) {
      window.open(
        "http://file-preview.icubespace.com/onlinePreview?url=" +
          encodeURIComponent(_Base64encode(item.fullPath)),
        "_blank"
      );
    },
    // 选择模型
    choose(item) {
      const resource_id = item._id;
      if (this.selectedResource[resource_id]) {
        const resourceIndex = this.chooseResourceArr.findIndex(
          (mod) => mod._id === resource_id
        );
        this.chooseResourceArr.splice(resourceIndex, 1);
        delete this.selectedResource[resource_id];
      } else {
        if (
          this.maxNumber === -1 ||
          this.chooseResourceArr.length < this.maxNumber
        ) {
          this.chooseResourceArr.push(item);
          this.selectedResource[resource_id] = item;
        } else {
          this.$store.dispatch(
            "global/showWarningMsg",
            "最多选择可" + this.maxNumber + "个资源"
          );
        }
      }
    },
    // 提交
    submit() {
      this.$emit("handleSubmit", this.chooseResourceArr);
    },
    // 返回
    cancel() {
      this.$emit("handleCancel");
    },
    handler(val) {
      this.$emit("update:dialogEdit", val);
    },
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.refreshResourceList();
      }
    },

    /**
     * 新增操作
     */
    handleResourceNew() {
      this.dialogFrom = true;
      this.$refs.ResourceLibraryFrom.reset();
      this.dialotitle = "新增";
    },

    /**
     * 新增/修改提交操作
     */
    handleSubmit(form) {
      console.log("form :>> ", form);
      const USER_INFO = localStorage.USER_INFO;
      if (form._id) {
        form.updater = USER_INFO.name || USER_INFO.username || "";
        updateResourceLibrary(form).then((res) => {
          console.log(res);
          if (res.code === "200") {
            this.$swal.fire("修改成功", "", "success");
            this.closeDialog();
            this.refreshResourceList();
          }
        });
      } else {
        form.creater = USER_INFO.name || USER_INFO.username || "";
        form.updater = USER_INFO.name || USER_INFO.username || "";
        addResourceLibrary(form).then((res) => {
          console.log(res);
          if (res.code === "200") {
            this.$swal.fire("新增成功", "", "success");
            this.closeDialog();
            this.refreshResourceList();
          }
        });
      }
    },
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.dialogFrom = false;
      this.editedItem = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}

.v-List-actived {
  background: #ddd;
}

.v-application .indigo--text {
  background: #fff;
}

.disable-color {
  color: #ddd !important;

  i {
    color: #ddd !important;
  }
}
.video {
  // width: 200px;
  // height: 180px;
  // margin: 0 !important;
}
</style>